<div class="copo-container">
	<ng-template #loadingOrError>
		<copo-loading-spinner *ngIf="isLoading"></copo-loading-spinner>
	</ng-template>
	<ng-container *ngIf="!isLoading; else loadingOrError">
		<div class="copo-section" #scrollRef>
			<div class="copo-section-body copo-grid">
				<div class="copo-grid-row header-fields-row">
					<div class="copo-grid-row-column-1">
						<mat-form-field class="copo-form-field">
							<mat-label translate>need4steel.wizard.header.customer-order-number</mat-label>
							<input
								#coNbrField
								type="text"
								matInput
								spellcheck="false"
								autocomplete="off"
								maxlength="32"
								[formControl]="form.getFormCoNbr()"
							>
							<mat-icon color="accent" class="icon-size" svgIcon="copo_pencil" matSuffix>
							</mat-icon>
							<mat-hint align="end">{{coNbrField.value.length || 0}}/32</mat-hint>
							<mat-error *ngIf="form.getFormCoNbr().invalid || form.getFormCoNbr().hasError('required')">
								<span translate>need4steel.wizard.header.customer-order-number.error.mandatory</span>
							</mat-error>
							<mat-error *ngIf="form.getFormCoNbr().hasError('pattern')">
								<span translate>need4steel.wizard.header.customer-order-number.error.invalid</span>
							</mat-error>
						</mat-form-field>
					</div>
					<div class="copo-grid-row-column-2" [ngClass]="{'hide-soldto': soldToBocList && getSoldToBocListSize(soldToBocList) < 2 }">
						<!-- SoldTo -->
						<mat-form-field [hideRequiredMarker]="true" class="copo-form-field">
							<mat-label translate>need4steel.wizard.header.soldto</mat-label>
							<mat-select [formControl]="form.getFormSoldTo()" #soldToField (selectionChange)="changeSoldTo();setSoldTo($event)">
								<mat-option
									*ngFor="let soldTo of soldToBocList|copoSortOptions:false:configForBoc"
									[value]="soldTo.businessId"
									[matTooltip]="soldTo.name +' / '+ soldTo.city"
								>
									{{soldTo.name}}&nbsp;/&nbsp;{{soldTo.city}}
								</mat-option>
							</mat-select>
							<mat-error *ngIf="form.getFormSoldTo().invalid || form.getFormSoldTo().hasError('required')">
								<span translate>need4steel.wizard.header.customer</span>
							</mat-error>
						</mat-form-field>
					</div>
					<div class="copo-grid-row-column-2" [ngClass]="{'copo-grid-row-column-1': soldToBocList && getSoldToBocListSize(soldToBocList) < 2 }">
						<!-- ShipTo -->
						<mat-form-field [hideRequiredMarker]="true" class="copo-form-field">
							<mat-label translate>need4steel.wizard.header.shipto</mat-label>
							<mat-select [formControl]="form.getFormShipTo()" (selectionChange)="setShipTo($event)">
								<mat-option *ngFor="let shipTo of getShipToList()|copoSortOptions:false:configForBoc" [value]="shipTo.businessId">
									<div class="copo-ship-to-name">{{shipTo.name}}&nbsp;/&nbsp;{{shipTo.city}}</div>
									<div class="copo-ship-to-address">
										{{shipTo.address}} {{shipTo.postalCode}} {{shipTo.city}} ({{shipTo.country}})
									</div>
								</mat-option>
							</mat-select>
							<mat-error *ngIf="form.getFormShipTo().invalid || form.getFormShipTo().hasError('required')">
								<span translate>need4steel.wizard.header.Delivery-address</span>
							</mat-error>
						</mat-form-field>
					</div>
					<div class="copo-grid-row-column-2" *ngIf="showEndUserSelection">
						<mat-form-field [hideRequiredMarker]="true" class="copo-form-field">
							<mat-label translate>eoffer.create.enduser</mat-label>
							<mat-select [formControl]="form.getFormEndUser()" #endUserField (selectionChange)="setEndUser($event)">
								<mat-option
									*ngFor="let endUser of getEndUserList()|copoSortOptions:false:configForBoc"
									[value]="endUser.businessId"
									[matTooltip]="endUser.name +' / '+ endUser.city"
								>
									{{endUser.name}}&nbsp;/&nbsp;{{endUser.city}}
								</mat-option>
							</mat-select>
							<mat-error *ngIf="form.getFormEndUser().hasError('required')">
								<span translate>eoffer.mandatory.enduser.reference</span>
							</mat-error>
						</mat-form-field>
					</div>
					<!-- Transport Mode (shown when mill is in allowed list) -->
					<div class="copo-grid-row-column-3" *ngIf="isShipmentSelectionEnabled">
						<mat-form-field class="copo-form-field">
							<mat-label translate>transport.mode</mat-label>
							<mat-select [formControl]="form.getFormTmode()" (selectionChange)="onTmodeChange($event)">
								<mat-option *ngFor="let tmod of tmodList" [value]="tmod.code">
									{{ tmod.value | translate }}
								</mat-option>
							</mat-select>
						</mat-form-field>
					</div>
					<div class="copo-grid-row-column-3 delivery-date-column" [ngClass]="{'copo-grid-row-column-4': soldToBocList && getSoldToBocListSize(soldToBocList) < 2 }">
						<!-- Delivery Date -->
						<div class="copo-form-field">
							<div class="card-content-label" translate>need4steel.wizard.header.delivery.date</div>
							<div class="card-content-value delivery-date-value" [matTooltip]="formdeliveryDate ? formdeliveryDate : ''">
								{{formdeliveryDate}}</div>
						</div>
					</div>
					<div class="copo-grid-row-column-4 mill-column" *ngIf="soldToBocList && getSoldToBocListSize(soldToBocList) < 2">
						<!-- Mill -->
						<div class="copo-form-field">
							<div class="card-content-label" translate>need4steel.wizard.header.mill</div>
							<div class="card-content-value" [matTooltip]="millSite ? millSite : ''">
								{{millSite}}
							</div>
						</div>
					</div>
				</div>
				<div class="copo-grid-row" *ngIf="soldToBocList && getSoldToBocListSize(soldToBocList) >= 2">
					<div class="copo-grid-row-column">
						<!-- Mill -->
						<div class="copo-form-field">
							<div class="card-content-label" translate>need4steel.wizard.header.mill</div>
							<div class="card-content-value" [matTooltip]="millSite ? millSite : ''">
								{{millSite}}
							</div>
						</div>
					</div>
					<div class="copo-grid-row-column-2"></div>
					<div class="copo-grid-row-column-2"></div>
					<div class="copo-grid-row-column-2"></div>
				</div>
			</div>
			<div *ngIf="(isShipToSoldTo && isSoldTo) && (isShipToSoldTo && isShipTo)">
				<div class="copo-section-header">
					<span translate>need4steel.wizard.step.product.title</span>
				</div>
				<copo-step-product-specification [millOfferData]="millOfferData" [shipToEvents]="shipToEvent"></copo-step-product-specification>
			</div>
		</div>
		<div class="copo-section copo-error-label" *ngIf="!isSoldTo || !isShipTo">
			Sorry, there is an issue in your service settings, please contact SteelUser administrator
		</div>
	</ng-container>
</div>
